import cls from './Share.module.scss';
import vkIcon from '../../assets/images/vk.svg';
import tgIcon from '../../assets/images/tg.svg';
import odkIcon from '../../assets/images/odk.svg';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { Pages } from '../../redux/page/types';
import { setShared } from '../../redux/game/slice';
import { sounds } from '../Sound/assets';

const defaultShareUrl = 'https://memesis.ru/artic';
const shareContent = {
  default: {
    title: 'Свистать всех наверх! ',
    text: 'Встань у штурвала мощнейшего ледокола.',
    image: defaultShareUrl + '/og/default.png',
    url: defaultShareUrl,
  },
  bad: {
    title: 'Статус: потерялся во льдах. ',
    text: 'Найдешь меня?',
    image: defaultShareUrl + '/og/bad.png',
    url: defaultShareUrl + '/result/bad.html',
  },
  normal: {
    title: 'Врезался в айсберг, чтобы почувствовать себя героем фильма. ',
    text: 'Хочешь также?',
    image: defaultShareUrl + '/og/normal.png',
    url: defaultShareUrl + '/result/normal.html',
  },
  lastBad: {
    title: 'Я на самом мощном ледоколе! Остальное неважно! ',
    text: 'Сможешь также?',
    image: defaultShareUrl + '/og/last-lost.png',
    url: defaultShareUrl + '/result/last-lost.html',
  },
  lastGood: {
    title: 'Мой ледокол смог! ',
    text: 'А твой сможет?',
    image: defaultShareUrl + '/og/last-lost',
    url: defaultShareUrl + '/result/best.html',
  },
};

export const Share = ({ style }: { style: React.CSSProperties }) => {
  const dispatch = useDispatch();
  const { currentPage, isSound } = useSelector((state: RootState) => state.page);
  const { currentLevel: level, isWin } = useSelector((state: RootState) => state.game);
  const [currentContent, setCurrentContent] = useState<{
    title: string;
    text: string;
    image: string;
    url: string;
  }>(shareContent.default);
  useEffect(() => {
    if (currentPage === Pages.FINAL || currentPage === Pages.PREFINAL) {
      if (level === 1) {
        setCurrentContent(shareContent.bad);
      } else if (level === 2) {
        setCurrentContent(shareContent.normal);
      } else if (level === 3) {
        if (isWin) {
          setCurrentContent(shareContent.lastGood);
          return;
        }

        setCurrentContent(shareContent.lastBad);
      }
    }
  }, [currentPage, isWin, level]);
  const onClickShare = () => {
    if (isSound) {
      sounds.btn.play();
    }
    setTimeout(() => {
      dispatch(setShared(true));
    }, 2000);
  };
  return (
    <div className={cls.Share} style={style}>
      <a
        target="_blank"
        rel="noreferrer"
        href={`https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.description=${currentContent.text}&st.imageUrl=${currentContent.image}&st.shareUrl=${currentContent.url}`}>
        <img alt="ODK Icon" src={odkIcon} onClick={onClickShare} />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href={`https://telegram.me/share/url?url=${currentContent.url}`}>
        <img alt="" src={tgIcon} onClick={onClickShare} />
      </a>

      <a
        target="_blank"
        rel="noreferrer"
        href={`https://vk.com/share.php?url=${currentContent.url}&title=${
          currentContent.title + currentContent.text
        }`}>
        <img alt="" src={vkIcon} onClick={onClickShare} />
      </a>
    </div>
  );
};
